import { render } from "./new_glo.vue?vue&type=template&id=9e9feb9e&scoped=true"
import script from "./new_glo.vue?vue&type=script&lang=js"
export * from "./new_glo.vue?vue&type=script&lang=js"

import "./new_glo.vue?vue&type=style&index=0&id=9e9feb9e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tap-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e9feb9e"]])

export default __exports__